<template>
  <div class="content-placeholder"
    :class="placeholderClass"
  >
    <error-ui v-if="error" :error="error" class="text-center"></error-ui>
    <div class="active-poll-container" v-else-if="activePoll">
    <span>{{ $t('attendance.quickPoll') }}</span>
    <div v-if="getCurrentCaption" class="subtitle-container">
      <p class="subtitle">{{ getCurrentCaption }}</p>
    </div>
    </div>

    <unsupported-browser v-else-if="!isBrowserSupported"></unsupported-browser>

    <hallway v-else-if="waitStart"></hallway>

    <div v-else-if="joining">
      <spinner size="3x"></spinner>
    </div>

    <thank-you v-else-if="left || ended"
      :left="left">
    </thank-you>
  </div>
</template>

<script>
import {SESSION_STATUS} from '@/store/modules/g2w-session';
import Hallway from '@/components/hallway';
import Spinner from '@/components/togo/spinner';
import UnsupportedBrowser from '@/components/unsupported-browser';
import ErrorUi from '@/components/error-ui';
import ThankYou from './thank-you';

const ContentPlaceholder = {
  name: 'ContentPlaceholder',

  components: {
    UnsupportedBrowser,
    ErrorUi,
    Hallway,
    ThankYou,
    Spinner
  },

  computed: {
    placeholderClass() {
      return {
        'placeholder-poll': this.activePoll
      };
    },

    isBrowserSupported() {
      return this.$store.getters['system/isBrowserSupported'];
    },

    error() {
      return this.$store.state.error;
    },

    getCurrentCaption () {
      const showCaptions = !!this.$store.state.recording.showCaptions
      const currentCaption = this.$store.state.recording.currentCaption
      if(showCaptions && currentCaption){
        return currentCaption
      } else {
        return null;
      }
    },

    sessionStatus() {
      return this.$store.state.g2wSession.sessionStatus;
    },

    joining() {
      return this.sessionStatus === SESSION_STATUS.joining;
    },

    waitStart() {
      return this.sessionStatus === SESSION_STATUS.waitStart;
    },

    left() {
      return this.sessionStatus === SESSION_STATUS.left;
    },

    ended() {
      return this.sessionStatus === SESSION_STATUS.ended;
    },

    activePoll() {
      return this.$store.state.g2wSession.polls.active;
    }
  }
};

export default ContentPlaceholder;
</script>

<style lang="sass">
  @import 'src/scss/variables'

  .content-placeholder
    display: flex
    justify-content: center
    align-items: center
    min-height: 200px

    &.placeholder-poll
      background-size: cover
      background-repeat: no-repeat
      background-position: center
      background-image: url('../../assets/quick-poll.jpg')
      font-size: 30px
      color: $white

    .active-poll-container 
      width: 100%
      display: flex
      justify-content: center


    .subtitle-container 
      position: absolute
      bottom: 100px
      display: flex
      flex-direction: column
      justify-content: center
      align-items: center
      gap: 10px;
      width: 100%

      .subtitle
        max-width: 50%
        background: rgba(11, 11, 11, 1)
        color: rgba(255, 255, 255, 1)
        font-family: Lato
        line-height: 28px
        font-size: 24px
        font-weight: 700
        padding: 10px
        margin: 0
</style>
